var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',_vm._g(_vm._b({attrs:{"color":"primary","target":"_blank"}},'BaseButton',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('v-icon',{staticClass:"ml-1",attrs:{"small":""}},[_vm._v(_vm._s(_vm.mdiOpenInNew))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }